<card name="Бейджи и вкладки">
  <div card content>
    <div class="form-group">
      <h3>Бейджи</h3>
      <div class="d-flex mx-n2">
        <span class="badge mx-2 badge-primary">Главный</span>
        <span class="badge mx-2 badge-secondary">Вторичный</span>
        <span class="badge mx-2 badge-success">Успех</span>
        <span class="badge mx-2 badge-danger">Опасность</span>
        <span class="badge mx-2 badge-warning d-inline-flex align-items-center">
          <icon-circle-attention class="text-warning mr-2"
                                 [style.width.px]="12"
                                 [style.height.px]="12">
          </icon-circle-attention>
          Предупреждение
        </span>
        <span class="badge mx-2 badge-info">Инфо</span>
        <span class="badge mx-2 badge-light">Светлый</span>
        <span class="badge mx-2 badge-dark">Темный</span>
      </div>
    </div>

    <div class="form-group">
      <h3>Табы Обычные</h3>
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a class="nav-link active" href="#">Active</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Link</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Link</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" href="#">Disabled</a>
        </li>
      </ul>
    </div>

    <div class="form-group">
      <h3>Табы Кнопочные</h3>
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a href="#" class="nav-link active btn btn-square btn-sm">
            <icon-plus></icon-plus>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link btn btn-square btn-sm">
            <icon-plus></icon-plus>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link btn btn-square btn-sm px-2">
            <icon-plus></icon-plus>
            <span class="ml-2">Добавить</span>
          </a>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link btn btn-square btn-sm disabled">
            <icon-plus></icon-plus>
          </a>
        </li>
      </ul>
    </div>
  </div>
</card>
